import React from "react";

export default class BlurReload extends React.Component {
  
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const blur = params.get('blur');
  
    if (blur == null) {
      window.onblur = this.onBlur.bind(this);
      window.onfocus = this.onFocus.bind(this);
    }
    
  }


  redirect() {
    console.log("redirect teaser");
    window.location.href = this.props.url;
  }

  onBlur() {
    console.log("set redirect timeout");

    this._timeout = setTimeout(() => {
      this.redirect();
    }, this.props.timeout);
  }

  onFocus() {
    if (this._timeout) {
      console.log("clear redirect timeout");
      clearTimeout(this._timeout);
    }
  }

  render() {
    return null;
  }

}
